module.exports = __webpack_public_path__ + "static/example_list-549bf0bbd270db6a2500569250c80370.png";